import { Button, Modal } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import AddAppointmentModalWrapper from "../calendar/components/addAppointment/AddAppointmentModalWrapper";
import PopAddNewClient from "../clients/PopAddNewClient";
import ModalOrder from "../sales/modals/ModalOrder";
type Props = {
  iconOnly?: boolean;
};

const QuickActionButton = ({ iconOnly = false }: Props) => {
  const [quickAction, setQuickAction] = useState(false);
  const [addingClientModal, setAddingClientModal] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const [dateAndTime, setDateAndTime] = useState<{
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  }>({
    date: null,
    startTime: null,
    finishTime: null,
  });
  const showQuickActionModal = () => {
    setQuickAction(true);
  };
  const canselQuickActionModal = () => {
    setQuickAction(false);
  };
  const showModal = () => {
    setIsAppointmentModalOpen(true);
    setQuickAction(false);
  };
  const handleCancel = () => {
    setIsAppointmentModalOpen(false);
  };
  const handleClient = () => {
    setAddingClientModal(true);
    setQuickAction(false);
  };
  const handleCloseClient = () => {
    setAddingClientModal(false);
  };
  const showOrderModal = () => {
    setIsOrderModalOpen(true);
    setQuickAction(false);
  };
  const handleOrderCancel = () => {
    setIsOrderModalOpen(false);
  };
  return (
    <>
      <Modal
        width="60%"
        open={quickAction}
        footer={null}
        centered
        onCancel={canselQuickActionModal}
        destroyOnClose={true}
        className="px-4 py-4 pb-10 max-md:!w-[95%] max-xl:!w-[75%] max-w-[750px]"
      >
        <div className="grid mb-8 text-center">
          <h3 className="mb-3 text-xl font-semibold text-color-primary">
            <FormattedMessage
              id="quick_action"
              defaultMessage="Quick Action!"
            />
          </h3>
          <p className="text-sm font-normal text-[#75757E]">
            <FormattedMessage
              id="quick_action_description"
              defaultMessage="Choose from the following what you want to do in a few simple steps"
            />
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center w-full gap-4">
          <div
            onClick={() => showModal()}
            className="flex bg-[#FBFBFF] rounded-lg p-4 flex-col items-center justify-center text-center w-[46%] cursor-pointer"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.49933 3.25C7.91354 3.25 8.24933 3.58579 8.24933 4V5.66763C11.0771 5.4158 13.9216 5.4158 16.7493 5.66763V4C16.7493 3.58579 17.0851 3.25 17.4993 3.25C17.9135 3.25 18.2493 3.58579 18.2493 4V5.81644C19.7424 6.02754 20.9219 7.20847 21.1216 8.71484L21.2081 9.36779C21.5722 12.1141 21.5407 14.8984 21.1148 17.6359C20.9037 18.9919 19.8021 20.0335 18.4363 20.1681L17.2433 20.2858C14.0883 20.5969 10.9103 20.5969 7.75525 20.2858L6.56225 20.1681C5.19651 20.0335 4.09485 18.9919 3.88384 17.6359C3.45788 14.8984 3.42644 12.1141 3.79048 9.36779L3.87703 8.71484C4.07671 7.20845 5.25626 6.02751 6.74933 5.81643V4C6.74933 3.58579 7.08511 3.25 7.49933 3.25ZM7.94449 7.2028C10.9737 6.90408 14.0249 6.90408 17.0541 7.2028L17.9596 7.2921C18.8263 7.37757 19.5201 8.04854 19.6346 8.91194L19.7211 9.56489C19.7514 9.793 19.7787 10.0214 19.8032 10.25H5.19539C5.21987 10.0214 5.24723 9.79301 5.27747 9.5649L5.36402 8.91194C5.47847 8.04854 6.17229 7.37757 7.03904 7.2921L7.94449 7.2028ZM5.07616 11.75C4.97798 13.6381 5.07471 15.5332 5.366 17.4052C5.47184 18.0854 6.02442 18.6078 6.70946 18.6754L7.90246 18.793C10.9596 19.0945 14.039 19.0945 17.0961 18.793L18.2891 18.6754C18.9742 18.6078 19.5268 18.0854 19.6326 17.4052C19.9239 15.5332 20.0206 13.6381 19.9224 11.75H5.07616Z"
                fill="#00086D"
              />
            </svg>
            <h4 className="font-semibold text-color-primary">
              <FormattedMessage
                id="new_appointment"
                defaultMessage="New Appointment"
              />
            </h4>
            <p className="text-[#75757E] font-semibold text-sm">
              <FormattedMessage
                id="new_appointment_description"
                defaultMessage="Book an appointment"
              />
            </p>
          </div>
          <div
            onClick={() => showOrderModal()}
            className="flex bg-[#FBFBFF] rounded-lg p-4 flex-col items-center justify-center text-center w-[46%] cursor-pointer"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex items-center justify-center mb-2"
            >
              <path
                d="M10.5 13.2501C10.9142 13.2501 11.25 13.5859 11.25 14.0001V16.0001C11.25 16.4143 10.9142 16.7501 10.5 16.7501C10.0858 16.7501 9.75 16.4143 9.75 16.0001V14.0001C9.75 13.5859 10.0858 13.2501 10.5 13.2501Z"
                fill="#00086D"
              />
              <path
                d="M15.25 14.0001C15.25 13.5859 14.9142 13.2501 14.5 13.2501C14.0858 13.2501 13.75 13.5859 13.75 14.0001V16.0001C13.75 16.4143 14.0858 16.7501 14.5 16.7501C14.9142 16.7501 15.25 16.4143 15.25 16.0001V14.0001Z"
                fill="#00086D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.1495 3.37513C10.3566 3.01641 10.2337 2.55771 9.875 2.35061C9.51628 2.1435 9.05759 2.26641 8.85048 2.62513L6.85048 6.08923C6.82052 6.14112 6.79746 6.19511 6.78103 6.25013H6.5C4.98122 6.25013 3.75 7.48134 3.75 9.00013C3.75 9.85925 4.14397 10.6264 4.76109 11.1307L5.42803 15.7154L5.87478 17.8085C6.14244 19.0626 7.16623 20.0152 8.43636 20.1919C11.1325 20.5671 13.8675 20.5671 16.5636 20.1919C17.8338 20.0152 18.8576 19.0626 19.1252 17.8085L19.572 15.7154L20.2389 11.1307C20.856 10.6264 21.25 9.85925 21.25 9.00013C21.25 7.48134 20.0188 6.25013 18.5 6.25013H18.219C18.2025 6.19511 18.1795 6.14112 18.1495 6.08923L16.1495 2.62513C15.9424 2.26641 15.4837 2.1435 15.125 2.35061C14.7663 2.55771 14.6434 3.01641 14.8505 3.37513L16.5104 6.25013H8.48963L10.1495 3.37513ZM18.6335 11.7469C18.5892 11.7491 18.5447 11.7501 18.5 11.7501H6.5C6.45525 11.7501 6.41076 11.7491 6.36653 11.7469L6.9053 15.4506L7.34174 17.4954C7.47772 18.1325 7.99783 18.6165 8.64308 18.7062C11.202 19.0623 13.798 19.0623 16.3569 18.7062C17.0022 18.6165 17.5223 18.1325 17.6583 17.4954L18.0947 15.4506L18.6335 11.7469ZM5.25 9.00013C5.25 8.30977 5.80964 7.75013 6.5 7.75013H18.5C19.1904 7.75013 19.75 8.30977 19.75 9.00013C19.75 9.69048 19.1904 10.2501 18.5 10.2501H6.5C5.80964 10.2501 5.25 9.69048 5.25 9.00013Z"
                fill="#00086D"
              />
            </svg>
            <h4 className="font-semibold text-color-primary">
              {" "}
              <FormattedMessage id="quick_order" defaultMessage="Quick Order" />
            </h4>
            <p className="text-[#75757E] font-semibold text-sm">
              <FormattedMessage
                id="quick_order_description"
                defaultMessage="Add a quick order to your sales."
              />{" "}
            </p>
          </div>
          <div
            onClick={() => handleClient()}
            className="flex bg-[#FBFBFF] rounded-lg p-4 flex-col items-center justify-center text-center w-[46%] cursor-pointer"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.75 7.5C6.75 5.15279 8.65279 3.25 11 3.25C13.3472 3.25 15.25 5.15279 15.25 7.5C15.25 9.84721 13.3472 11.75 11 11.75C8.65279 11.75 6.75 9.84721 6.75 7.5ZM11 4.75C9.48122 4.75 8.25 5.98122 8.25 7.5C8.25 9.01878 9.48122 10.25 11 10.25C12.5188 10.25 13.75 9.01878 13.75 7.5C13.75 5.98122 12.5188 4.75 11 4.75Z"
                fill="#00086D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.25 17C3.25 14.9289 4.92893 13.25 7 13.25H7.34087C7.52536 13.25 7.70869 13.2792 7.88407 13.3364L8.74959 13.6191C10.2119 14.0965 11.7881 14.0965 13.2504 13.6191L14.1159 13.3364C14.2913 13.2792 14.4746 13.25 14.6591 13.25H15C17.0711 13.25 18.75 14.9289 18.75 17V18.1883C18.75 18.9415 18.2041 19.5837 17.4607 19.7051C13.1819 20.4037 8.8181 20.4037 4.53927 19.7051C3.79588 19.5837 3.25 18.9415 3.25 18.1883V17ZM7 14.75C5.75736 14.75 4.75 15.7574 4.75 17V18.1883C4.75 18.2064 4.76311 18.2218 4.78097 18.2247C8.89972 18.8972 13.1003 18.8972 17.219 18.2247C17.2369 18.2218 17.25 18.2064 17.25 18.1883V17C17.25 15.7574 16.2426 14.75 15 14.75H14.6591C14.6328 14.75 14.6066 14.7542 14.5815 14.7623L13.716 15.045C11.9512 15.6212 10.0488 15.6212 8.28398 15.045L7.41847 14.7623C7.39342 14.7542 7.36722 14.75 7.34087 14.75H7Z"
                fill="#00086D"
              />
              <path
                d="M19.5 6.25C19.9142 6.25 20.25 6.58579 20.25 7V8.75H22C22.4142 8.75 22.75 9.08579 22.75 9.5C22.75 9.91421 22.4142 10.25 22 10.25H20.25V12C20.25 12.4142 19.9142 12.75 19.5 12.75C19.0858 12.75 18.75 12.4142 18.75 12V10.25H17C16.5858 10.25 16.25 9.91421 16.25 9.5C16.25 9.08579 16.5858 8.75 17 8.75H18.75V7C18.75 6.58579 19.0858 6.25 19.5 6.25Z"
                fill="#00086D"
              />
            </svg>

            <h4 className="font-semibold text-color-primary">
              <FormattedMessage
                id="add_new_client"
                defaultMessage="Add New Client"
              />
            </h4>
            <p className="text-[#75757E] font-semibold text-sm">
              <FormattedMessage
                id="add_new_client_description"
                defaultMessage="Add a client to your salon."
              />
            </p>
          </div>
        </div>
      </Modal>
      <Modal
        width="80%"
        open={addingClientModal}
        onCancel={handleCloseClient}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <PopAddNewClient close={handleCloseClient} />
      </Modal>
      <Modal
        width="40%"
        destroyOnClose={true}
        maskClosable={false}
        centered
        className="overflow-y-auto max-md:!w-[95%] max-xl:!w-[75%]"
        open={isAppointmentModalOpen}
        onCancel={handleCancel}
        footer={false}
      >
        <AddAppointmentModalWrapper
          setIsModalOpen={setIsAppointmentModalOpen}
          dateAndTime={dateAndTime}
          setDateAndTime={setDateAndTime}
        />
      </Modal>
      <Modal
        width="40%"
        destroyOnClose={true}
        maskClosable={false}
        centered
        className="overflow-y-auto max-md:!w-[95%] max-xl:!w-[75%]"
        open={isOrderModalOpen}
        onCancel={handleOrderCancel}
        footer={false}
      >
        <ModalOrder close={handleOrderCancel} />
      </Modal>
      <Button
        type="primary"
        onClick={() => showQuickActionModal()}
        // style={{ width: 150 }}
        className={
          "flex items-center justify-center gap-1 " + iconOnly
            ? ""
            : "w-[150px]"
        }
      >
        {!iconOnly ? (
          <span className="text-[14px] font-semibold">
            <FormattedMessage id="quickAction" />
          </span>
        ) : null}
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.4319 9.52339C15.5262 9.33491 15.4791 9.12287 15.3377 8.98151L13.2408 6.95533L14.3953 4.26947C14.466 4.08099 14.4188 3.86894 14.2775 3.72758C14.1361 3.58622 13.9005 3.56266 13.7356 3.6569L11.1911 5.04695L9.02356 3.11502C8.8822 2.97366 8.6466 2.9501 8.48168 3.04434C8.31675 3.13858 8.22251 3.35062 8.24607 3.5391L8.7644 6.41345L6.26702 7.89774C6.10209 7.99198 6.00785 8.20402 6.05497 8.3925C6.10209 8.58099 6.24345 8.74591 6.4555 8.76947L8.74084 9.07575L0.141361 17.6988C-0.0471204 17.8873 -0.0471204 18.17 0.141361 18.3585C0.235602 18.4527 0.353403 18.4998 0.471204 18.4998C0.589005 18.4998 0.706806 18.4527 0.801047 18.3585L9.42408 9.73544L9.94241 12.0443C9.98953 12.2328 10.1545 12.3977 10.3429 12.4213C10.3665 12.4213 10.3901 12.4213 10.3901 12.4213C10.5785 12.4213 10.7435 12.3271 10.8141 12.1621L12.0628 9.52339L14.9372 9.80612C15.1492 9.80612 15.3613 9.68832 15.4319 9.52339ZM11.8508 8.53387C11.6623 8.5103 11.4738 8.62811 11.3796 8.79303L10.5785 10.4894L10.178 8.65167C10.1309 8.46318 9.96597 8.32182 9.77749 8.29826L7.91623 8.0391L9.54188 7.07313C9.70681 6.97889 9.80105 6.76685 9.75393 6.57837L9.42408 4.74067L10.8141 5.98936C10.9555 6.13072 11.1675 6.15428 11.356 6.06004L13.0052 5.16476L12.2749 6.90821C12.2042 7.09669 12.2513 7.28518 12.3691 7.42654L13.7356 8.74591L11.8508 8.53387Z"
            fill="white"
          />
          <path
            d="M12.8399 11.0552C12.6279 11.1966 12.5572 11.5029 12.6985 11.7149L13.7588 13.317C13.853 13.4584 13.9944 13.529 14.1593 13.529C14.2535 13.529 14.3478 13.5055 14.4184 13.4584C14.6305 13.317 14.7012 13.0107 14.5598 12.7987L13.4996 11.1966C13.3347 10.961 13.0519 10.8903 12.8399 11.0552Z"
            fill="white"
          />
          <path
            d="M10.6953 0.971204V2.85602C10.6953 3.11518 10.9074 3.32723 11.1665 3.32723C11.4257 3.32723 11.6377 3.11518 11.6377 2.85602V0.971204C11.6377 0.712042 11.4257 0.5 11.1665 0.5C10.9074 0.5 10.6953 0.712042 10.6953 0.971204Z"
            fill="white"
          />
          <path
            d="M15.693 6.81404L18.2139 6.17791C18.4731 6.10723 18.6144 5.84807 18.5437 5.61247C18.4731 5.37686 18.2139 5.21194 17.9783 5.28262L15.4573 5.91875C15.1982 5.98943 15.0568 6.24859 15.1275 6.48419C15.1746 6.69624 15.3631 6.8376 15.5752 6.8376C15.6223 6.8376 15.6458 6.8376 15.693 6.81404Z"
            fill="white"
          />
          <path
            d="M4.54525 4.71723C4.28608 4.67011 4.05048 4.85859 4.00336 5.09419C3.95624 5.35336 4.14472 5.58896 4.38033 5.63608L6.24158 5.94236C6.26514 5.94236 6.2887 5.94236 6.31226 5.94236C6.54787 5.94236 6.73635 5.77744 6.78347 5.54184C6.83059 5.28268 6.64211 5.04707 6.4065 4.99995L4.54525 4.71723Z"
            fill="white"
          />
        </svg>
      </Button>
    </>
  );
};

export default QuickActionButton;
